import { ActivePanelManager, getParents } from '@infotech-soe/erp-ui-kit';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import DatasetService from '../../../services/dataset/DatasetService';
import { AppState } from '../../../store/reducers/root';
import {
  getActiveCategoryId,
  getContextActiveTabs,
  getContextIds,
} from '../../../store/selectors/content';
import { getLastActiveFormId } from '../../../store/selectors/form';

const mapStateToProps = (state: AppState) => ({
  containerIds: getContextIds(state),
  containerActive: getLastActiveFormId(state) || getActiveCategoryId(state),
  containerActiveTabs: getContextActiveTabs(state),
});

const mapDispatchProps = () => ({
  buildFocusHandler: ({ focusTarget }: any) => {
    const service = new DatasetService();

    if (focusTarget.dataset.datasetId) {
      return () => {
        service.focus(focusTarget.dataset.datasetId as string);

        // fallback for empty grid
        if (
          document.activeElement === document.body ||
          !document.activeElement ||
          !focusTarget.contains(document.activeElement)
        ) {
          const focusable = getParents(focusTarget).find(
            (el: HTMLElement) => el.tabIndex > -1
          );

          if (focusable) {
            focusable.focus();
          }
        }
      };
    }
  },
});

const connector = connect(mapStateToProps, mapDispatchProps);

export type ActivePanelManagerContainerProps = ConnectedProps<typeof connector>;

export default connector(ActivePanelManager);
